if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentImageIndex = 0;
        this.images = [];
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        console.log('ProductModal opened'); // Debug log
        this.showActiveMedia();
        this.createLightboxGallery();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        
        // Find current image index
        const allMedia = this.querySelectorAll('[data-media-id]');
        this.currentImageIndex = Array.from(allMedia).indexOf(activeMedia);
        
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      createLightboxGallery() {
        console.log('Creating lightbox gallery'); // Debug log
        
        // Remove existing gallery if present
        const existingGallery = this.querySelector('.lightbox-gallery');
        if (existingGallery) {
          existingGallery.remove();
        }

        // Get all images - fix the selector
        this.images = Array.from(this.querySelectorAll('[data-media-id]')).filter(media => {
          const img = media.querySelector('img');
          return img; // Just check if image exists
        });

        console.log('Found images:', this.images.length); // Debug log

        if (this.images.length <= 1) {
          console.log('Not enough images for gallery');
          return;
        }

        // Create thumbnail gallery at bottom
        const gallery = document.createElement('div');
        gallery.className = 'lightbox-gallery';
        gallery.innerHTML = `
          <div class="lightbox-nav">
            <button class="lightbox-prev" aria-label="Previous image">❮</button>
            <div class="lightbox-thumbnails">
              ${this.images.map((media, index) => {
                const img = media.querySelector('img');
                const isActive = media.classList.contains('active') ? 'active' : '';
                return `
                  <button class="lightbox-thumb ${isActive}" data-index="${index}" aria-label="Image ${index + 1}">
                    <img src="${img.src}" alt="${img.alt || ''}" loading="lazy">
                  </button>
                `;
              }).join('')}
            </div>
            <button class="lightbox-next" aria-label="Next image">❯</button>
          </div>
          <div class="lightbox-counter">
            <span class="current">${this.currentImageIndex + 1}</span> / <span class="total">${this.images.length}</span>
          </div>
        `;

        // Add gallery to modal
        const modalContent = this.querySelector('.product-media-modal__content');
        console.log('Modal content found:', !!modalContent); // Debug log
        
        if (modalContent) {
          modalContent.appendChild(gallery);
          console.log('Gallery added to modal'); // Debug log
        } else {
          console.log('Modal content not found, trying alternative selector');
          const altModalContent = this.querySelector('[role="document"]');
          if (altModalContent) {
            altModalContent.appendChild(gallery);
            console.log('Gallery added to alternative modal content'); // Debug log
          }
        }

        // Add event listeners
        this.addGalleryEventListeners();
      }

      addGalleryEventListeners() {
        // Thumbnail clicks
        this.querySelectorAll('.lightbox-thumb').forEach((thumb, index) => {
          thumb.addEventListener('click', () => this.switchToImage(index));
        });

        // Navigation arrows
        const prevBtn = this.querySelector('.lightbox-prev');
        const nextBtn = this.querySelector('.lightbox-next');
        
        if (prevBtn) {
          prevBtn.addEventListener('click', () => this.previousImage());
        }
        
        if (nextBtn) {
          nextBtn.addEventListener('click', () => this.nextImage());
        }

        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
          if (!this.hasAttribute('open')) return;
          
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.previousImage();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.nextImage();
          }
        });
      }

      switchToImage(index) {
        if (index < 0 || index >= this.images.length) return;
        
        // Hide all images
        this.images.forEach(img => img.classList.remove('active'));
        
        // Show selected image
        this.images[index].classList.add('active');
        this.currentImageIndex = index;
        
        // Update thumbnails
        this.querySelectorAll('.lightbox-thumb').forEach((thumb, i) => {
          thumb.classList.toggle('active', i === index);
        });
        
        // Update counter
        const counter = this.querySelector('.lightbox-counter .current');
        if (counter) {
          counter.textContent = index + 1;
        }
      }

      previousImage() {
        const newIndex = this.currentImageIndex > 0 ? this.currentImageIndex - 1 : this.images.length - 1;
        this.switchToImage(newIndex);
      }

      nextImage() {
        const newIndex = this.currentImageIndex < this.images.length - 1 ? this.currentImageIndex + 1 : 0;
        this.switchToImage(newIndex);
      }
    }
  );
}
